import { getHostName } from '../utils/getHostName';

export function getSiteCoreApiUrl(): string {
  const hostname = process.env.REACT_APP_OMNI_CMS_MOCK_SITECORE_PATH === 'true' ? '/api' : getHostName();
  const url = `${hostname}/cw/api`;
  return url.replace(/\s/g, '%20');
}
